export const STYLE_ADD ='STYLE_ADD'

export const STYLE_REMOVE ='STYLE_REMOVE'